import { Subject } from '../models';
import { Subject as SubjectEntity } from 'adc-sirius-module-common';
import { urls } from '../utilities/dataHelpers';
import {
  mapSubjectEntityToSubject,
  mapSubjectToSubjectEntity,
} from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';

const handleGetSubjects = (request: MediatorRequestWithResponse<Subject[]>) => {
  const status = request.status;
  const siteKey = request.siteKey;

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SubjectEntity[]>('api:invoke', {
        method: 'GET',
        url: `${urls.api}subjects/site/${siteKey}`,
        queryString: status ? `?rowstate=${status}` : '',
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(
            (result.data ?? []).map((subjectEntity) =>
              mapSubjectEntityToSubject(subjectEntity),
            ),
          );
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching subjects:', err);
        reject(err);
      });
  });
};

const handleGetSubjectByKey = (
  request: MediatorRequestWithResponse<Subject>,
) => {
  request.response = new Promise((resolve, reject) => {
    const subjectKey = request.key;

    mediator
      .request<SubjectEntity>('api:invoke', {
        method: 'GET',
        url: `${urls.api}subjects/${subjectKey}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSubjectEntityToSubject(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching subject by ID:', err);
        reject(err);
      });
  });
};

const handleCreateSubject = (request: MediatorRequestWithResponse<Subject>) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SubjectEntity>('api:invoke', {
        method: 'POST',
        url: urls.api + 'subjects',
        data: mapSubjectToSubjectEntity(request.data),
      })
      .then((result) => {
        if (result.status === 201) {
          resolve(mapSubjectEntityToSubject(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error creating subject:', err);
        reject(err);
      });
  });
};

const handleUpdateSubject = (request: MediatorRequestWithResponse<Subject>) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SubjectEntity>('api:invoke', {
        method: 'PUT',
        url: `${urls.api}subjects`,
        data: mapSubjectToSubjectEntity(request.data),
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSubjectEntityToSubject(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error updating subject:', err);
        reject(err);
      });
  });
};

const handleCreateSubjectNote = (
  request: MediatorRequestWithResponse<Subject>,
) => {
  request.response = new Promise((resolve, reject) => {
    const subjectKey = request.key;

    mediator
      .request<SubjectEntity>('api:invoke', {
        method: 'POST',
        url: `${urls.api}subjects/${subjectKey}/notes`,
        data: request.data,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSubjectEntityToSubject(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error creating subject note:', err);
        reject(err);
      });
  });
};

mediator.subscribe('subject:getSubjects', handleGetSubjects);
mediator.subscribe('subject:getSubjectByKey', handleGetSubjectByKey);
mediator.subscribe('subject:createSubject', handleCreateSubject);
mediator.subscribe('subject:updateSubject', handleUpdateSubject);
mediator.subscribe('subject:createSubjectNote', handleCreateSubjectNote);
